import { useMsal } from '@azure/msal-react';

export default {
  useMsal
};
